import Vue from 'vue';
// 创建一个空的 Vue 实例作为事件总线
export const eventBus = new Vue();    